import Rollbar from "rollbar"; // This exports the plugin object.

export var RollbarPlugin = {
  install: function install(Vue, options) {
    Vue.prototype.$rollbar = new Rollbar(options);
  }
};